<template>
  <ContentPage :back="{ name: 'leads/show', params: { id } }">
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">Choose a Pro</div>
    </template>

    <Section class="px-10 py-8">
      <v-btn :disabled="disabled" color="primary" x-large class="justify-start" @click="autoPickClick">
        <div class="d-flex">
          <v-icon>mdi-bullseye-arrow</v-icon>
          <div class="ml-4 text-left">
              <div>Auto Select</div>
              <div style="font-size: 12px; text-transform: none">(Let the robot choose!)</div>
          </div>
        </div>
      </v-btn>

      <v-btn :disabled="disabled" @click="manualPickClick" x-large class="justify-start mt-6">
        <div class="d-flex">
          <v-icon>mdi-account-wrench-outline</v-icon>
          <div class="ml-4 text-left">
              <div>Let me Choose</div>
              <div style="font-size: 12px; text-transform: none">(I want control!)</div>
          </div>
        </div>
      </v-btn>
    </Section>

    <ErrorOverlay title="Can't add more Pros" v-model="error_dialog" :loading="false">
      {{ error_message }}
    </ErrorOverlay>
  </ContentPage>
</template>


<script>
import { ContentPage, Section } from '@/components/pages'
import { mapActions, mapGetters } from 'vuex'
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

export default {
  name: 'LeadsChooseMethod',
  
  mixins: [ ErrorOverlayMixin ],

  components: { ContentPage, Section },

  props: ['id'],

  data() {
    return {
      disabled: false,
    }
  },

  computed: {
    ...mapGetters('customer_requests', ['currentRequest']),

    previous_pros() {
      return this.currentRequest?.blocked_ids || []
    },
  },

  methods: {
    ...mapActions('customer_requests', ['loadCurrent']),

    async autoPickClick() {
      this.$router.replace({ name: 'leads/confirm', params: { automatic: true } })
    },

    manualPickClick() {
      this.$router.replace({ name: 'leads/append' })
    },
  },

  async created() {
    this.disabled = true

    await this.loadCurrent(this.id)

    this.disabled = false
  },
}
</script>